import type {
  NameSanitizationRule,
  PreviewNameSanitizationResponse,
  RunNameCleaningResponse,
} from '@shared/schemas';

export type LoadStatus = 'idle' | 'loading' | 'loaded' | 'failed';

/** Any write in flight: adding a rule, deleting one, or running the pass. */
export type MutationStatus = 'idle' | 'pending' | 'failed';

/**
 * Redux state for the admin Name rules screen.
 *
 * `lastRun` is kept after the pass settles rather than surfaced as a snackbar and
 * dropped: its four figures are the only report of an operation that cannot be
 * undone, and `skipped_admin_edited` in particular is what explains a low
 * `cleaned` count on a hand-curated base. Ephemeral UI (the typed test name, the
 * confirm dialog's open flag) stays local to the page.
 */
export interface NameRulesState {
  rules: NameSanitizationRule[];
  loadStatus: LoadStatus;
  mutation: { status: MutationStatus; error: string | null };
  preview: PreviewNameSanitizationResponse | null;
  running: boolean;
  lastRun: RunNameCleaningResponse | null;
}

export const initialState: NameRulesState = {
  rules: [],
  loadStatus: 'idle',
  mutation: { status: 'idle', error: null },
  preview: null,
  running: false,
  lastRun: null,
};
